import baseAPI from '@/api/base';
import { EditEmployeeContract, GetEmployeeContract, RegisterEmployeeContract } from '@/dtos/employee_contract.dto';
import {
  DELETE_EMPLOYEE_CONTRACT_URL,
  EDIT_EMPLOYEE_CONTRACT_URL,
  GET_EMPLOYEE_CONTRACT_URL,
  REGISTER_EMPLOYEE_CONTRACT_URL,
  TOGGLE_EMPLOYEE_CONTRACT_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class EmployeeContract {
  static getEmployeeContracts = async (getEmployeeContract: GetEmployeeContract): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_CONTRACT_URL, {
      params: getEmployeeContract,
    });
    console.log('response', response);
    return response;
  };

  static registerEmployeeContract = async (
    registerEmployeeContract: RegisterEmployeeContract
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_EMPLOYEE_CONTRACT_URL, {
      ...registerEmployeeContract,
    });
    console.log('response', response);
    return response;
  };

  static editEmployeeContract = async (editEmployeeContract: EditEmployeeContract): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_EMPLOYEE_CONTRACT_URL, {
      ...editEmployeeContract,
    });
    return response;
  };

  static toggleEmployeeContractIsActive = async (
    editEmployeeContract: EditEmployeeContract
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_EMPLOYEE_CONTRACT_IS_ACTIVE_URL,
      {
        ...editEmployeeContract,
      }
    );
    return response;
  };

  static deleteEmployeeContract = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_EMPLOYEE_CONTRACT_URL}/${userId}`
    );
    return response;
  };
}

export default EmployeeContract;
